import Editor from './base/editor';
import focusInput from '@intercom/embercom-composer/lib/focus-input';
import $ from 'jquery';
import { reads } from '@ember/object/computed';
import { schedule } from '@ember/runloop';
import Em from 'ember';
export default Editor.extend({
  keysToTriggerClose: [9, 27],
  keepSelectedOnDismiss: true,
  classNames: ['is-light-theme', 'composer-video-file-editor'],
  classNameBindings: ['isEditMode:composer-editor-is-active'],
  hasCaptions: reads('editableObject.hasCaptions'),
  isEditMode: false,
  dimensionsChanged: Em.observer({
    dependentKeys: ['isEditMode'],
    fn() {
      schedule('afterRender', this, this.setupEditorDimensions);
    },
    sync: true
  }),
  actions: {
    editCaptions() {
      this.set('isEditMode', true);
      schedule('afterRender', this, function () {
        focusInput($('textarea', this.element));
      });
    },
    dismiss() {
      if (!this.get('isDestroying')) {
        this.set('isEditMode', false);
      }
    },
    completedEditing(value) {
      this.set('editableObject.captions', value);
      this.set('isEditMode', false);
      this.get('editableObject').captionsUpdated();
    }
  }
});